const { Students } = require('./Students')
const { CreateStudent } = require('./CreateStudent');
const { UpdateStudent } = require('./UpdateStudent');

export { Students, CreateStudent, UpdateStudent }
